import React from 'react'
import ReactDOM from 'react-dom/client'
import 'form-pattern/dist/main.css'
import "tabs-pattern/dist/foundation.css";
import './index.css'
import App from './App.tsx';
import { ReduxProvider } from './store/ReduxProvider'
import 'pl-js-utility';
import { detectEnvironmentFromUrl, getEnvironmentConfig } from './utils/detectEnv'

console.log('React app starting...');

// ============================================
// Detect Environment from URL
// ============================================

const detectedEnv = detectEnvironmentFromUrl();
const defaultEnvConfig = getEnvironmentConfig();
const externalEnvConfig = ((globalThis as any).envConfig ?? {}) as Record<string, unknown>

const envConfig = {
  ...defaultEnvConfig,
  ...externalEnvConfig,
}

console.log('Environment Detection:');
console.log(' Detected Environment:', detectedEnv);

// Store globally for OAuth config (on both window and globalThis for compatibility)
// (window as any).detectedEnv = detectedEnv;
// (window as any).envConfig = envConfig;
(globalThis as any).detectedEnv = detectedEnv;
(globalThis as any).envConfig = envConfig;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ReduxProvider>
      <App />
    </ReduxProvider>
  </React.StrictMode>
)
